import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { name: 'Code', prop: 'code', type: 'text' },
  { name: 'Created', prop: 'created_at', format: 'fromNow' },
  { name: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by code', prop: 'filters.code_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const PromoCodes = (props) => (
  <List
    title='Promo Codes'
    apiPath='admin/promo_codes'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default PromoCodes
